import { render, staticRenderFns } from "./LeftComponent.vue?vue&type=template&id=00398293&scoped=true&"
import script from "./LeftComponent.vue?vue&type=script&lang=js&"
export * from "./LeftComponent.vue?vue&type=script&lang=js&"
import style0 from "./LeftComponent.vue?vue&type=style&index=0&id=00398293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00398293",
  null
  
)

export default component.exports